<template>
  <div>
    <v-row justify="space-around" max-width="820px">
      <reflection-entry></reflection-entry>
    </v-row>
    <reflection-item
      v-for="reflection in reflections"
      v-bind:reflection="reflection"
      v-bind:key="reflection.id"
    ></reflection-item>
  </div>
</template>

<style lang="css" scoped></style>

<script>
import { ReflectionsAPI } from "@/lib/api"
import titleMixin from "@/mixins/titleMixin"
import User from "@/lib/user"
import ReflectionEntry from "@/components/reflections/ReflectionEntry"
import ReflectionItem from "@/components/reflections/ReflectionItem"
import EventBus from "@/lib/eventBus"

export default {
  mixins: [titleMixin],
  components: {
    ReflectionEntry,
    ReflectionItem
  },
  data: function() {
    return {
      title: "Reflection",
      reflections: []
    }
  },
  methods: {
    GetReflections: function() {
      let userId = User.getUserId()
      ReflectionsAPI.list({ userId }).then(response => {
        this.reflections = response
      })
    }
  },
  created() {
    EventBus.$on("ReflectionAdded", () => {
      this.GetReflections()
    })
    this.GetReflections()
  }
}
</script>
